/**
 * ProgressBar - Quiz Progress Indicator
 * 
 * Shows current progress through the quiz.
 */

import React from 'react';

type BarType = 'full' | 'text';

interface ProgressBarProps {
  current: number;
  total: number;
  bartype?: BarType;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  total,
  bartype = 'full',
}) => {
  const percentage = Math.min((current / total) * 100, 100);

  return bartype === 'text' ? (
      <span className='progress-status'>Question {current} of {total}</span>
  ) : (
    <div className="progress-bar-container">
      <div className="progress-bar">
        <div
          className="progress-bar-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>

      <span className="progress-text">
        Question {current} of {total}
      </span>
    </div>
  );
};

export default ProgressBar;
